import { render, staticRenderFns } from "./backup-file-preview-dialog.component.vue?vue&type=template&id=084b99f5"
import script from "./backup-file-preview-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-file-preview-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports